<template>
  <div class="cond_item">
    <type-select class="cond_select" v-model="classify" />
    <!-- 各种条件 -->
    <base-condition
      v-if="[0, 1].includes(+rule.classify)"
      :rule="rule"
      :classify-type="rule.classify"
      :key="`baseCondition${rule.classify}`"
    />
    <label-condition v-else-if="'2' == rule.classify" :rule="rule" />
    <QuestionCondition v-else-if="'3' == rule.classify" :condition="rule.condition" :questionList="questionList" v-bind="$attrs" v-on="$listeners" />
    <span class="del_btn" v-if="showRemove" @click="$emit('remove', rule)">
      <i class="el-icon-remove-outline"></i>
    </span>
  </div>
</template>

<script>
import TypeSelect from './ConditionTypeSelect'
import BaseCondition from './BaseCondition'
import LabelCondition from './LabelCondition'
import QuestionCondition from '@/condition/question/QuestionCondition'
import { convertQuestion, createQuestion, normalizeNum } from '@/question/factory'
export default {
  name: 'ConditionItem',
  components: {
    TypeSelect,
    BaseCondition,
    LabelCondition,
    QuestionCondition
  },
  props: {
    rule: {
      type: Object,
      default: () => ({})
    },
    showRemove: {
      type: Boolean,
      default: true
    },
    questionList: {
      type: Array,
      default: ()=>( [])
    },
    condition: {
      type: Object,
      default: () => ({})
    },

  },
  computed: {
    classify: {
      get() {
        return `${this.rule.classify ?? ''}`
      },
      set(val) {
        this.rule.classify = Number.isNaN(+val) ? 0 : +val
      }
    }
  },
  mounted(){
    const questionList = this.questionList;
    const questionNewList = [];
    questionList.forEach(it=> {
      questionNewList.push(convertQuestion(it));
    })
    console.log('questionNewList',questionNewList)
  }
}
</script>

<style lang="scss" scoped>
.cond_item {
  display: flex;
  align-items: center;
  .cond_select {
    width: 105px;
    margin-right: 8px;
  }
  .del_btn {
    margin-left: 8px;
    cursor: pointer;
  }
}
</style>
